/**
 * Die Audit-Schublade der View-Seiten (REQ-26 §2.4). Der Ersatzwert `0` für
 * `EntryId=@(SelectedModelId ?? 0)` ist in allen vier Ansichten gleich.
 *
 * Name und Eigenschaften bleiben, damit die vier Seiten unverändert bleiben; Position und Ziel
 * entfallen mit `AuditSidebar`, weil die Schublade (REQ-25 §1) immer rechts über der ganzen
 * Anwendung liegt statt in der Seitenfläche.
 */

import { AuditDrawer } from '@/components/sidebars/AuditDrawer';
import type { EntityTypes } from '@/types/enums';

export interface ViewAuditSidebarProps {
  entity: EntityTypes;
  viewId: number;
  selectedId: number | null;
  open: boolean;
  onClose(): void;
}

export function ViewAuditSidebar(props: ViewAuditSidebarProps) {
  return (
    <AuditDrawer
      entity={props.entity}
      viewId={props.viewId}
      entryId={props.selectedId ?? 0}
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
    />
  );
}

export default ViewAuditSidebar;
